import { render, staticRenderFns } from "./GChipSelect.vue?vue&type=template&id=1e6ae79a&"
import script from "./GChipSelect.vue?vue&type=script&lang=js&"
export * from "./GChipSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChip,VChipGroup})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6ae79a')) {
      api.createRecord('1e6ae79a', component.options)
    } else {
      api.reload('1e6ae79a', component.options)
    }
    module.hot.accept("./GChipSelect.vue?vue&type=template&id=1e6ae79a&", function () {
      api.rerender('1e6ae79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/GChipSelect.vue"
export default component.exports